module.exports = __webpack_public_path__ + "img/integralShop_bg.cf2e5ff4.jpg";